/* eslint-disable max-len */

export type GetPaymentsListRes = {
  count: number
  next: string | null
  previous: string | null
  results: {
    id: number
    accomodation: {
      id: number
      accomcategory: number
      accom_type: string
      name: string
      city: number
      address: string
      url: string | null
      status: number
      status_verbose: string
      service_end_date: string
      thumbnail_url: string
      thumbnail_small_url: string
      thumbnail_medium_url: string
      thumbnail_big_url: string
      is_in_active_region: boolean
    }
    service: {
      id: string | null
      service: {
        name: string
      }
      start_date: string | null
      end_date: string | null
      price_fixed: string
      discount_value: string | null
      discount_desc: string | null
      status: number
      status_verbose: number
    }
    bill: {
      id: string
      bill_uid: string
      accom_service: number
      create_date: string
      amount: number
      paid_date: string | null
      paid_type: number
      paid_type_verbose: string
      status: number
      status_verbose: string
    } | null
    pay_form_state: string
  }[]
}


export type GetPaymentsListReq = {}

// Тип ответа для получения конкретного счёта
export type GetBillRes = {
  id: number
  bill_uid: string
  name: string
  accom_service: number
  create_date: string
  amount: number
  paid_date: string | null
  paid_type: number
  paid_type_verbose: string
  status: number
  status_verbose: string
  payment_status: number
  payment_status_verbose: string
  payment_status_date: string | null
  payment_uuid: string | null
}

export const GET_PAYMENTS_LIST = '/v1/account/payments/'
export const GET_PAYMENT = '/v1/account/payments/:accommodationId/'
export const GET_BILL = '/v1/payments/bill_info/:billUid/'
export const CREATE_PAYMENT = '/v1/account/payments/:accommodationId/create_bill/'
